module.exports = __webpack_public_path__ + "media/images/HubbleIQ_black-b371c6887101b83c74f19be0df65d2aa.png";